import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import MyProjectsPanel from './MyProjectsPanel'
import ProjectPage from '@root/Project/ProjectPage'
import { Route } from 'react-router-dom'
import './MyProjects.sass'

class MyProjects extends Component {
  render () {
    return (
      <DocumentTitle title='My projects | Atheneum Partners'>
        <div className='expert-search'>
          <MyProjectsPanel />
          <Route path='/my-projects/project/:id' component={ProjectPage} />
        </div>
      </DocumentTitle>
    )
  }
}

export default MyProjects
